import NewEmployeeDocument from "./document/NewEmployeeDocument";
import EditEmployeeDocument from "./document/EditEmployeeDocument";
import Employee from "./employee/Employee";
import NewEmployee from "./employee/NewEmployee";
import EditEmployee from "./employee/EditEmployee";
import Employees from "./employee/Employees";
import OrgDocuments from "./document/OrgDocuments";
import NewOrgDocument from "./document/NewOrgDocument";
import EditOrgDocument from "./document/EditOrgDocument";
import NewEquipmentDocument from "./document/NewEquipmentDocument";
import EditEquipmentDocument from "./document/EditEquipmentDocument";
import NewVehicleDocument from "./document/NewVehicleDocument";
import EditVehicleDocument from "./document/EditVehicleDocument";
import Tags from "./tag/Tags";
import Tag from "./tag/Tag";
import NewTag from "./tag/NewTag";
import EditTag from "./tag/EditTag";
import SetupTypes from "./setuptype/SetupTypes";
import Mansions from "./mansion/Mansions";
import Mansion from "./mansion/Mansion";
import NewMansion from "./mansion/NewMansion";
import EditMansion from "./mansion/EditMansion";
import AbsenceTypes from "./absencetype/AbsenceTypes";
import Absences from "./absence/Absences";
import Absence from "./absence/Absence";
import NewAbsence from "./absence/NewAbsence";
import EditAbsence from "./absence/EditAbsence";
import AbsenceType from "./absencetype/AbsenceType";
import NewAbsenceType from "./absencetype/NewAbsenceType";
import EditAbsenceType from "./absencetype/EditAbsenceType";
import WorkSites from "./worksite/WorkSites";
import WorkSite from "./worksite/WorkSite";
import NewWorkSite from "./worksite/NewWorkSite";
import EditWorkSite from "./worksite/EditWorkSite";
import NewPosRequest from "./worksite/NewPosRequest";
import NewPos from "./pos/NewPos";
import PosModels from "./posmodel/PosModels";
import PosModel from "./posmodel/PosModel";
import NewPosModel from "./posmodel/NewPosModel";
import EditPosModel from "./posmodel/EditPosModel";
import SetupType from "./setuptype/SetupType";
import NewSetupType from "./setuptype/NewSetupType";
import EditSetupType from "./setuptype/EditSetupType";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import {
  Await,
  createBrowserRouter,
  Link,
  Navigate,
  Outlet,
  redirect,
  RouterProvider,
  useLoaderData,
} from "react-router";
import CheckLogin from "./CheckLogin";
import itIT from "antd/locale/it_IT";
import { ConfigProvider, Descriptions, Skeleton, theme } from "antd";
import dayjs from "dayjs";
import it from "dayjs/locale/it";
import PdfViewer from "./common/PdfViewer";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import App from "./App";
import FetchUserInfo from "./FetchUserInfo";
import duration from "dayjs/plugin/duration";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import DpiTypes from "./dpitype/DpiTypes";
import NewDpiType from "./dpitype/NewDpiType";
import EditDpiType from "./dpitype/EditDpiType";
import DpiType from "./dpitype/DpiType";
import DpiProducts from "./dpi/DpiProducts";
import DpiProduct from "./dpi/DpiProduct";
import NewDpiProduct from "./dpi/NewDpiProduct";
import EditDpiProduct from "./dpi/EditDpiProduct";
import DpiInventoryUnits from "./dpi/inventoryunit/DpiInventoryUnits";
import DpiInventoryUnit from "./dpi/inventoryunit/DpiInventoryUnit";
import DpiTransactions from "./dpi/DpiTransactions";
import NewDpiTransaction from "./dpi/NewDpiTransaction";
import DpiTransaction from "./dpi/DpiTransaction";
import Courses from "./course/Courses";
import Course from "./course/Course";
import UploadCertificate from "./course/UploadCertificate";
import NewCourse from "./course/NewCourse";
import EditCourse from "./course/EditCourse";
import CourseTypes from "./coursetype/CourseTypes";
import NewCourseType from "./coursetype/NewCourseType";
import EditCourseType from "./coursetype/EditCourseType";
import AppointmentTypes from "./appointmenttype/AppointmentTypes";
import NewAppointmentType from "./appointmenttype/NewAppointmentType";
import EditAppointmentType from "./appointmenttype/EditAppointmentType";
import Appointments from "./appointment/Appointments";
import NewAppointment from "./appointment/NewAppointment";
import AppointmentDetails from "./appointment/AppointmentDetails";
import EditAppointment from "./appointment/EditAppointment";
import Doctors from "./doctor/Doctors";
import NewDoctor from "./doctor/NewDoctor";
import EditDoctor from "./doctor/EditDoctor";
import MedicalVisits from "./medicalvisit/MedicalVisits";
import NewMedicalVisit from "./medicalvisit/NewMedicalVisit";
import MedicalVisit from "./medicalvisit/MedicalVisit";
import UploadMedicalFitness from "./medicalvisit/UploadMedicalFitness";
import EditMedicalVisit from "./medicalvisit/EditMedicalVisit";
import EditMedicalFitness from "./medicalvisit/EditMedicalFitness";
import VehicleTypes from "./vehicletype/VehicleTypes";
import VehicleType from "./vehicletype/VehicleType";
import Vehicles from "./vehicle/Vehicles";
import Vehicle from "./vehicle/Vehicle";
import NewVehicle from "./vehicle/NewVehicle";
import EditVehicle from "./vehicle/EditVehicle";
import VehicleSetupForm from "./vehicle/VehicleSetupForm";
import VehicleSetup from "./vehicle/VehicleSetup";
import NewVehicleType from "./vehicletype/NewVehicleType";
import EditVehicleType from "./vehicletype/EditVehicleType";
import EquipmentTypes from "./equipmenttype/EquipmentTypes";
import NewEquipmentType from "./equipmenttype/NewEquipmentType";
import EditEquipmentType from "./equipmenttype/EditEquipmentType";
import WorkActivities from "./workactivity/WorkActivities";
import WorkActivity from "./workactivity/WorkActivity";
import NewWorkActivity from "./workactivity/NewWorkActivity";
import Equipments from "./equipment/Equipments";
import NewEquipment from "./equipment/NewEquipment";
import Equipment from "./equipment/Equipment";
import EditEquipment from "./equipment/EditEquipment";
import AssignEquipment from "./equipment/AssignEquipment";
import { HomeOutlined } from "@ant-design/icons";
import axiosInstance, { api } from "./common/api";
import DeferredComponent from "./common/DeferredComponent";
import EquipmentType from "./equipmenttype/EquipmentType";
import ResourceAllocation from "./allocation/ResourceAllocation";
import NewInspection from "./inspection/NewInspection";
import EditInspection from "./inspection/EditInspection";
import Dashboard from "./dashboard/Dashboard";
import NewVehicleSetupDocument from "./vehicle/NewVehicleSetupDocument";
import EditVehicleSetupDocument from "./vehicle/EditVehicleSetupDocument";
import MobileDpiForm from "./mobiledpi/MobileDpiForm";
import MobileApp from "./mobile/MobileApp";
import Success from "./mobile/Success";
import MobileEquipment from "./mobileequipment/MobileEquipment";
import PickEquipment from "./mobileequipment/PickEquipment";
import MobileAssignEquipment from "./mobileequipment/MobileAssignEquipment";
import MobileReturnEquipment from "./mobileequipment/MobileReturnEquipment";
import Export from "./export/Export";

// Register all Community features
const root = ReactDOM.createRoot(document.getElementById("root"));
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(duration);
dayjs.extend(isSameOrAfter);

const route = (
  path,
  resource,
  { listCrumb, detailCrumb },
  { NewElement, ListElement, DetailsElement, EditElement },
  detailRoutes = [],
) => ({
  path: path,
  handle: { crumb: listCrumb },
  children: [
    { index: true, element: ListElement },
    {
      path: "new",
      handle: { crumb: "Nuovo" },
      element: NewElement,
      action: ({ request }) =>
        request
          .json()
          .then((form) => api[resource].create(form))
          .then(() => redirect("..")),
    },
    {
      path: ":id",
      handle: { crumb: detailCrumb },
      id: resource,
      loader: ({ params }) => api[resource].get(params.id),
      shouldRevalidate: ({ nextUrl, currentUrl, defaultShouldRevalidate }) => {
        if (nextUrl.pathname === currentUrl.pathname) return false;
        return defaultShouldRevalidate;
      },
      children: [
        { index: true, element: DetailsElement },
        {
          path: "edit",
          loader: ({ params }) => api[resource].get(params.id),
          handle: { crumb: "Modifica" },
          element: EditElement,
          action: ({ request, params }) =>
            request
              .json()
              .then((form) => api[resource].update(params.id, form))
              .then(() => redirect("..")),
        },
        ...detailRoutes,
      ],
    },
  ],
});

const router = createBrowserRouter([
  {
    path: "/mobile",
    element: (
      <CheckLogin>
        <div style={{ height: "100vh", overflowY: "auto", backgroundColor: "#f5f5f5" }}>
          <Outlet />
        </div>
      </CheckLogin>
    ),
    children: [
      {
        index: true,
        element: <MobileApp />,
      },
      {
        path: "dpiDelivery",
        element: <MobileDpiForm type={"delivery"} />,
      },
      {
        path: "dpiReturn",
        element: <MobileDpiForm type={"return"} />,
      },
      {
        path: "equipments",
        children: [
          { index: true, element: <PickEquipment /> },
          {
            path: ":id",
            children: [
              {
                index: true,
                loader: ({ params }) => api.equipment.get(params.id),
                element: <MobileEquipment />,
              },
              { path: "assign", element: <MobileAssignEquipment /> },
              {
                path: "unassign",
                element: <MobileReturnEquipment />,
                loader: ({ params }) => api.equipment.get(params.id),
              },
            ],
          },
        ],
      },
      {
        path: "success",
        element: <Success />,
      },
    ],
  },
  {
    path: "/",
    handle: { crumb: <HomeOutlined /> },
    element: (
      <CheckLogin>
        <App />
      </CheckLogin>
    ),
    children: [
      route(
        "employees",
        "employee",
        { listCrumb: "Dipendenti", detailCrumb: (data) => data.fullName },
        {
          ListElement: <Employees />,
          NewElement: <NewEmployee />,
          DetailsElement: <Employee />,
          EditElement: <EditEmployee />,
        },
        [
          {
            path: "documents/new",
            handle: { crumb: "Nuovo documento" },
            element: <NewEmployeeDocument />,
          },
          {
            path: "documents/:documentId/edit",
            handle: { crumb: "Modifica documento" },
            element: <EditEmployeeDocument />,
            loader: async ({ params }) => {
              const document = await api.document.get(params.documentId);
              if (document.type !== "EMPLOYEE" || String(document.sourceId) !== params.id)
                throw new Response("Not found", { status: 404 });
              return document;
            },
          },
        ],
      ),
      {
        path: "orgDocuments",
        handle: { crumb: "Documenti aziendali" },
        children: [
          { index: true, element: <OrgDocuments /> },
          { path: "new", handle: { crumb: "Nuovo documento" }, element: <NewOrgDocument /> },
          {
            path: ":documentId/edit",
            handle: { crumb: "Modifica documento" },
            element: <EditOrgDocument />,
            loader: async ({ params }) => {
              const document = await api.document.get(params.documentId);
              if (document.type !== "ORG" || document.sourceId != null)
                throw new Response("Not found", { status: 404 });
              return document;
            },
          },
        ],
      },
      route(
        "dpis",
        "dpi",
        { listCrumb: "Categorie DPI", detailCrumb: "Dettaglio" },
        {
          NewElement: <NewDpiType />,
          ListElement: <DpiTypes />,
          DetailsElement: <DpiType />,
          EditElement: <EditDpiType />,
        },
      ),
      {
        path: "/dpi",
        loader: () => redirect("/dpis"),
      },
      route(
        "dpiProducts",
        "dpiProduct",
        { listCrumb: "Prodotti DPI", detailCrumb: "Dettaglio prodotto" },
        {
          ListElement: <DpiProducts />,
          NewElement: <NewDpiProduct />,
          EditElement: <EditDpiProduct />,
          DetailsElement: <DpiProduct />,
        },
      ),
      route(
        "dpiInventoryUnits",
        "dpiInventoryUnit",
        { listCrumb: "Matricole DPI", detailCrumb: (record) => record.serialNumber },
        {
          ListElement: <DpiInventoryUnits />,
          DetailsElement: <DpiInventoryUnit />,
        },
        [
          {
            path: "newInspection",
            handle: { crumb: "Nuova revisione" },
            element: <NewInspection />,
          },
          {
            path: "inspections/:inspectionId/edit",
            handle: { crumb: "Modifica revisione" },
            element: <EditInspection />,
            loader: async ({ params }) => {
              const inspection = await api.inspection.get(params.inspectionId);
              if (inspection.type !== "DPI" || String(inspection.dpi) !== params.id)
                throw new Response("Not found", { status: 404 });
              return inspection;
            },
            action: ({ request, params }) =>
              request
                .json()
                .then((form) => api.inspection.update(params.inspectionId, form))
                .then(() => redirect("..")),
          },
        ],
      ),
      {
        path: "/dpiTransactions",
        element: <DpiTransactions />,
      },
      {
        path: "/dpiTransactions/new",
        element: <NewDpiTransaction />,
      },
      {
        path: "/dpiTransactions/:id",
        element: <DpiTransaction />,
      },
      route(
        "courses",
        "course",
        { listCrumb: "Corsi", detailCrumb: "Dettaglio corso" },
        {
          NewElement: <NewCourse />,
          EditElement: <EditCourse />,
          ListElement: <Courses />,
          DetailsElement: <Course />,
        },
        [
          {
            path: "certificate",
            handle: { crumb: "Carica attestato" },
            loader: ({ params }) => api.course.get(params.id),
            element: <UploadCertificate />,
          },
        ],
      ),
      {
        path: "/courseTypes",
        element: <CourseTypes />,
      },
      {
        path: "/courseTypes/new",
        element: <NewCourseType />,
      },
      {
        path: "/courseTypes/:id/edit",
        element: <EditCourseType />,
      },
      {
        path: "appointmentTypes",
        element: <AppointmentTypes />,
      },

      {
        path: "appointmentTypes/new",
        element: <NewAppointmentType />,
      },
      {
        path: "appointmentTypes/:id/edit",
        element: <EditAppointmentType />,
      },
      route(
        "appointments",
        "appointment",
        { listCrumb: "Nomine", detailCrumb: "Dettaglio nomina" },
        {
          ListElement: <Appointments />,
          DetailsElement: <AppointmentDetails />,
          EditElement: <EditAppointment />,
          NewElement: <NewAppointment />,
        },
      ),
      {
        path: "doctors",
        element: <Doctors />,
      },
      {
        path: "doctors/new",
        element: <NewDoctor />,
      },
      {
        path: "doctors/:id/edit",
        element: <EditDoctor />,
      },
      {
        path: "medicalVisits",
        element: <MedicalVisits />,
      },
      route(
        "medicalVisits",
        "medicalVisit",
        { listCrumb: "Visite mediche", detailCrumb: "Dettaglio visita medica" },
        {
          ListElement: <MedicalVisits />,
          NewElement: <NewMedicalVisit />,
          DetailsElement: <MedicalVisit />,
          EditElement: <EditMedicalVisit />,
        },
        [
          {
            path: "uploadMedicalFitness",
            handle: { crumb: "Carica idoneità" },
            element: <UploadMedicalFitness />,
          },
          {
            path: "editMedicalFitness",
            handle: { crumb: "Modifica idoneità" },
            element: <EditMedicalFitness />,
          },
        ],
      ),
      route(
        "vehicleTypes",
        "vehicleType",
        { listCrumb: "Categorie veicoli", detailCrumb: "Dettaglio categoria" },
        {
          NewElement: <NewVehicleType />,
          ListElement: <VehicleTypes />,
          DetailsElement: <VehicleType />,
          EditElement: <EditVehicleType />,
        },
      ),
      route(
        "setupTypes",
        "setupType",
        { listCrumb: "Categorie allestimenti", detailCrumb: "Dettaglio categoria" },
        {
          NewElement: <NewSetupType />,
          ListElement: <SetupTypes />,
          DetailsElement: <SetupType />,
          EditElement: <EditSetupType />,
        },
      ),
      route(
        "vehicles",
        "vehicle",
        { listCrumb: "Veicoli", detailCrumb: (data) => data.plate },
        {
          NewElement: <NewVehicle />,
          ListElement: <Vehicles />,
          DetailsElement: <Vehicle />,
          EditElement: <EditVehicle />,
        },
        [
          {
            path: "documents/new",
            handle: { crumb: "Nuovo documento" },
            element: <NewVehicleDocument />,
          },
          {
            path: "documents/:documentId/edit",
            handle: { crumb: "Modifica documento" },
            element: <EditVehicleDocument />,
            loader: ({ params }) => api.document.get(params.documentId),
          },
          {
            path: "setups",
            handle: { crumb: "Allistimenti" },
            children: [
              {
                path: "new",
                handle: { crumb: "Nuovo allestimento" },
                element: <VehicleSetupForm />,
                loader: () =>
                  api.setupType.list({ pageSize: 9999 }).then(({ data }) => ({ types: data })),
                action: ({ request, params }) =>
                  request
                    .json()
                    .then((form) =>
                      api.vehicleSetup.create({ ...form, vehicle: Number(params.id) }),
                    )
                    .then(() => redirect("..")),
              },
              {
                path: ":setupId",
                id: "setup",
                handle: { crumb: (data) => data.model },
                loader: async ({ params }) => {
                  const setup = await api.vehicleSetup.get(params.setupId);
                  if (String(setup.vehicle.id) !== params.id)
                    throw new Response("Not found", { status: 404 });
                  return setup;
                },
                children: [
                  {
                    path: "newInspection",
                    handle: { crumb: "Nuova revisione" },
                    element: <NewInspection />,
                  },
                  {
                    path: "inspections/:inspectionId/edit",
                    handle: { crumb: "Modifica revisione" },
                    element: <EditInspection />,
                    loader: async ({ params }) => {
                      const inspection = await api.inspection.get(params.inspectionId);
                      if (
                        inspection.type !== "SETUP" ||
                        String(inspection.setup) !== params.setupId
                      )
                        throw new Response("Not found", { status: 404 });
                      return inspection;
                    },
                    action: ({ request, params }) =>
                      request
                        .json()
                        .then((form) => api.inspection.update(params.inspectionId, form))
                        .then(() => redirect("..")),
                  },
                  {
                    index: true,
                    element: <VehicleSetup />,
                  },
                  {
                    path: "edit",
                    handle: { crumb: "Modifica allestimento" },
                    element: <VehicleSetupForm />,
                    action: ({ request, params }) =>
                      request
                        .json()
                        .then((form) =>
                          api.vehicleSetup.update(params.setupId, {
                            ...form,
                            vehicle: Number(params.id),
                          }),
                        )
                        .then(() => redirect("..")),
                  },
                  {
                    path: "documents/new",
                    handle: { crumb: "Nuovo documento" },
                    element: <NewVehicleSetupDocument />,
                  },
                  {
                    path: "documents/:documentId/edit",
                    handle: { crumb: "Modifica documento" },
                    element: <EditVehicleSetupDocument />,
                    loader: ({ params }) => api.document.get(params.documentId),
                  },
                ],
              },
            ],
          },
          {
            path: "newInspection",
            handle: { crumb: "Nuova revisione" },
            element: <NewInspection />,
            action: ({ request }) =>
              request
                .json()
                .then((form) => api.inspection.create(form))
                .then(() => redirect("..")),
          },
          {
            path: "inspections/:inspectionId/edit",
            handle: { crumb: "Modifica revisione" },
            element: <EditInspection />,
            loader: ({ params }) => api.inspection.get(Number(params.inspectionId)),
            action: ({ request, params }) =>
              request
                .json()
                .then((form) => api.inspection.update(Number(params.inspectionId), form))
                .then(() => redirect("..")),
          },
        ],
      ),
      route(
        "workSites",
        "workSite",
        { listCrumb: "Cantieri", detailCrumb: "Dettaglio cantiere" },
        {
          NewElement: <NewWorkSite />,
          ListElement: <WorkSites />,
          DetailsElement: <WorkSite />,
          EditElement: <EditWorkSite />,
        },
        [
          {
            path: "posRequest",
            handle: { crumb: "Nuova richiesta POS" },
            element: <NewPosRequest />,
            action: ({ request, params }) =>
              request
                .json()
                .then((form) => api.posRequest.create({ ...form, workSite: Number(params.id) }))
                .then(() => redirect("..")),
          },
          {
            path: "pos/new",
            handle: { crumb: "Nuovo POS" },
            element: <NewPos />,
            action: ({ request }) =>
              request
                .json()
                .then((form) => api.pos.create(form))
                .then(() => redirect("..")),
          },
        ],
      ),
      {
        path: "posModels",
        handle: { crumb: "Modelli POS" },
        children: [
          { index: true, element: <PosModels /> },
          {
            path: "new",
            handle: { crumb: "Nuovo" },
            element: <NewPosModel />,
            action: ({ request }) =>
              request
                .formData()
                .then((form) => api.posModel.create(form))
                .then(() => redirect("..")),
          },
          {
            path: ":id",
            id: "posModel",
            handle: { crumb: "Dettaglio modello" },
            loader: ({ params }) => api.posModel.get(params.id),
            children: [
              { index: true, element: <PosModel /> },
              {
                path: "edit",
                handle: { crumb: "Modifica" },
                element: <EditPosModel />,
                loader: ({ params }) => api.posModel.get(params.id),
                action: ({ request, params }) =>
                  request
                    .json()
                    .then((form) => api.posModel.update(params.id, form))
                    .then(() => redirect("..")),
              },
            ],
          },
        ],
      },
      route(
        "absenceTypes",
        "absenceType",
        { listCrumb: "Categorie assenze", detailCrumb: "Dettaglio categoria" },
        {
          NewElement: <NewAbsenceType />,
          ListElement: <AbsenceTypes />,
          DetailsElement: <AbsenceType />,
          EditElement: <EditAbsenceType />,
        },
      ),
      route(
        "absences",
        "absence",
        { listCrumb: "Assenze", detailCrumb: "Dettaglio assenza" },
        {
          NewElement: <NewAbsence />,
          ListElement: <Absences />,
          DetailsElement: <Absence />,
          EditElement: <EditAbsence />,
        },
      ),
      {
        path: "resourceAllocation",
        element: <ResourceAllocation />,
      },
      route(
        "workActivities",
        "workActivity",
        { listCrumb: "Attività lavorative", detailCrumb: "Dettaglio attività" },
        {
          NewElement: <NewWorkActivity />,
          ListElement: <WorkActivities />,
          DetailsElement: <WorkActivity />,
          EditElement: <Navigate to=".." replace />,
        },
      ),
      route(
        "mansions",
        "mansion",
        { listCrumb: "Mansioni", detailCrumb: "Dettaglio mansione" },
        {
          NewElement: <NewMansion />,
          ListElement: <Mansions />,
          DetailsElement: <Mansion />,
          EditElement: <EditMansion />,
        },
      ),
      route(
        "tags",
        "tag",
        { listCrumb: "Tag", detailCrumb: "Dettaglio tag" },
        {
          NewElement: <NewTag />,
          ListElement: <Tags />,
          DetailsElement: <Tag />,
          EditElement: <EditTag />,
        },
      ),
      route(
        "equipmentTypes",
        "equipmentType",
        { listCrumb: "Categorie attrezzature", detailCrumb: "Dettaglio categoria" },
        {
          NewElement: <NewEquipmentType />,
          ListElement: <EquipmentTypes />,
          DetailsElement: <EquipmentType />,
          EditElement: <EditEquipmentType />,
        },
      ),
      route(
        "equipments",
        "equipment",
        { listCrumb: "Attrezzature", detailCrumb: (record) => record.serialCode },
        {
          NewElement: <NewEquipment />,
          ListElement: <Equipments />,
          DetailsElement: <Equipment />,
          EditElement: <EditEquipment />,
        },
        [
          {
            path: "documents/new",
            handle: { crumb: "Nuovo documento" },
            element: <NewEquipmentDocument />,
          },
          {
            path: "documents/:documentId/edit",
            handle: { crumb: "Modifica documento" },
            element: <EditEquipmentDocument />,
            loader: ({ params }) => api.document.get(params.documentId),
          },
          {
            path: "assign",
            action: ({ request, params }) =>
              request
                .json()
                .then((form) => api.equipmentAssignment.create(form))
                .then(() => redirect("..")),
            handle: { crumb: "Assegna" },
            element: <AssignEquipment />,
          },
          {
            path: "newInspection",
            handle: { crumb: "Nuova revisione" },
            element: <NewInspection />,
          },
          {
            path: "inspections/:inspectionId/edit",
            handle: { crumb: "Modifica revisione" },
            element: <EditInspection />,
            loader: async ({ params }) => {
              const inspection = await api.inspection.get(params.inspectionId);
              if (inspection.type !== "EQUIPMENT" || String(inspection.equipment) !== params.id)
                throw new Response("Not found", { status: 404 });
              return inspection;
            },
            action: ({ request, params }) =>
              request
                .json()
                .then((form) => api.inspection.update(params.inspectionId, form))
                .then(() => redirect("..")),
          },
        ],
      ),
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "export",
        element: <Export/>
      }
    ],
  },
]);

dayjs.locale("it");

Date.prototype.stdTimezoneOffset = function () {
  var jan = new Date(this.getFullYear(), 0, 1);
  var jul = new Date(this.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};

Date.prototype.isDstObserved = function () {
  return this.getTimezoneOffset() < this.stdTimezoneOffset();
};

const { compactAlgorithm } = theme;
root.render(
  <ConfigProvider
    locale={itIT}
    theme={{
      token: {
        borderRadius: 8,
        colorPrimary: "#B8892D",
        colorSplit: "#b0b0b059", // Dividers and separator lines
        colorBorder: "#b0b0b059", // Default component borders
        colorBorderSecondary: "#b0b0b059", // Subtle borders
      },
      components: {
        Listy: {
          itemPaddingBlock: 4,
        },
        Table: {
          //          cellPaddingBlock: 8,
          //          cellPaddingInline: 8,
          //          headerBorderRadius: 0,
          //          headerBg: 'white',
        },
        Descriptions: {
          labelBg: "transparent",
          colorTextSecondary: "rgba(0,0,0,0.45)",
        },
        Menu: {
          colorSplit: "transparent",
        },
        Button: {
          //paddingInline: 8,
        },
      },
    }}
  >
    <>
      <RouterProvider router={router} />
    </>
  </ConfigProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
